export default __webpack_public_path__ + "img/43083ee39f2f70ef4a86680196a3c36c.svg";